import { confirmMes } from '@/shared/utilities';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import { addMembers } from '../services/conversation.service';
import { deleteMembers } from '../services/member.service';
import { conversationKeys } from './conversation-keys';

export const useMemberDelete = (conversationId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (userId: string) => deleteMembers(conversationId, [userId]),
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: conversationKeys.member(conversationId)
        });
      }, 1000);
    }
  });

  return {
    xoa: async (memberId: string) => {
      const res = await confirmMes({
        title: i18next.t('conversations.members.removeDialogTitle'),
        description: i18next.t('conversations.members.removeDescription')
      });
      if (res) {
        toast.promise(() => mutateAsync(memberId), {
          pending: i18next.t('conversations.delete.deleting'),
          success: i18next.t('conversations.toasts.removeMemberSuccess')
        });
      }
    }
  };
};

export const useMemberAdd = (conversationId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userIds: string[]) => addMembers(conversationId, userIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: conversationKeys.member(conversationId)
      });
    }
  });
};
